// This file will contain all constant required for project
const Constants = {
    ImportFolderPath: "/CaesarVision Files", //Provide csv files folder path from active Excel file to import data
    ExportFolderPath: "/QBO Files", //Provide folder path from active Excel file to save/export final csv file
    ImportDataSheetName: "Sales Entry Import",
    ExportDataSheetName: "JE_Output",
    LogSheetName: "Logs",
    LogSheetColumns: {
        Type: "Type", Time: "Time", Message: "Message"
    },
    // Session Storage key names 
    StorageKeys: {
        IsLogSheetExist: "EE.QBO.IsLogSheetExist",
        LogsSheetLastRow: "EE.QBO.LogsSheetLastRow",
    },
    // Set document setting save value keys
    SettingKeys: {
        QBOToken: "EE.QBO.Token",
        QBOUserInfo: "EE.QBO.UserInfo",
        QBOCompanyInfo: "EE.QBO.CompanyInfo",
        QBOClassList: "EE.QBO.ClassList",
        QBOAccounts: "EE.QBO.Accounts"
    },
    WorkBookNames: {
        KnownStore: "knownStore",
        DateCount: "dateCount",
        JournalEntryBalance: "jeBalance",
        Class: "storeClass",
        StartDate: "startDate"
    }
}
export default Constants;